import { Component, inject } from '@angular/core';
import { PermissionsFormComponent } from "../permissions-form/permissions-form.component";
import { PermissionsService } from '../services/permissions.service';
import { AccessService } from '../../core/services/access.service';

@Component({
  selector: 'app-permissions-create',
  standalone: true,
  imports: [PermissionsFormComponent],
  templateUrl: './permissions-create.component.html',
  styleUrl: './permissions-create.component.css'
})
export class PermissionsCreateComponent {
  private service = inject(PermissionsService)

  protected access = inject(AccessService).access

  ngOnInit(): void {
    this.service.title.update((value) => 'Nuevo Permiso')
  }
}
